import React from 'react';
import FormDataImgUploader from './components/FormDataImgUploader/FormDataImgUploader';
import InputFields from './components/InputFields/InputFields';
import classNames from 'classnames';
import style from './CreationForm.module.scss';

interface ICreationForm {
	isVisible: boolean;
}

const CreationForm: React.FC<ICreationForm> = ({ isVisible }) => {
	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	return (
		<div className={containerClasses} data-test="CreationForm">
			<FormDataImgUploader />
			<InputFields />
		</div>
	);
};

export default CreationForm;
